module.exports = __webpack_public_path__ + "static/media/goodnest_app5_preview.ae12affb.jpg";